import { Module } from "vuex";
import { IRootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { IProvidersUser } from "@/models/providers-user";

export interface IProvidersUsersState {
    usersScopedList: IProvidersUser[] | null;
    usersScopedCPList: IProvidersUser[] | null;
    usersUnscopedList: IProvidersUser[] | null;
    selectedProvidersUser: IProvidersUser | null;
    isSelectedProvidersUser: boolean;
    scopedUsersError: any;
    unscopedUsersError: any;
}

export const getDefaultProvidersUsersState = (): IProvidersUsersState => {
    return {
        usersScopedList: [],
        usersUnscopedList: [],
        usersScopedCPList:[],
        selectedProvidersUser: null,
        isSelectedProvidersUser: false,
        scopedUsersError: null,
        unscopedUsersError: null,
    };
};

const state = getDefaultProvidersUsersState();

const namespaced: boolean = true;

export const providersUsers: Module<IProvidersUsersState, IRootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
